import { configureStore } from '@reduxjs/toolkit'
import { createBrowserHistory } from 'history'
import { persistReducer, persistStore } from 'redux-persist'
import { encryptTransform } from 'redux-persist-transform-encrypt'
import storage from 'redux-persist/lib/storage'

import { soyshareApi } from '../../services/api'
import { listenerMiddleware } from '../middlewares'
import combinedReducers from '../reducers'

const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_REDUX_SECRET_KEY || 'fallback-key',
  onError: console.error
})

const persistConfig = {
  key: 'root',
  storage,
  timeout: null,
  whitelist: ['auth'],
  transforms: [encryptor]
}

const middlewares = [soyshareApi.middleware, listenerMiddleware.middleware]

const persistedReducer = persistReducer(persistConfig, combinedReducers)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(middlewares),
  devTools: process.env.NODE_ENV === 'development'
})

export const persistor = persistStore(store)
export const history = createBrowserHistory()

export default store
